import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { flatten } from 'lodash';
import { withContent, isContentType } from 'components/Content';
import RichText from 'components/RichText';
import { hasBrandTag } from 'components/Content/utils';
import ProductGridItem from 'components/ContentfulFields/ProductCard/ProductGridItem';
import { useTheme } from '@material-ui/core/styles';
import { useMediaQuery } from '@material-ui/core';
import arrowLeft from 'images/arrow_circle_left.png';
import arrowRight from 'images/arrow_circle_right.png';
import { getCurrencyCode } from 'utils/translation';
import { dataLayerPush } from 'utils/tracking';

import styles from './styles.scss';

const CONTENT_KEYS = {
  header: 'Header',
  footer: 'Footer',
};

const CONTENT_TYPE_KEYS = {
  familyGroups: 'section',
};
const FamilyProductBundles = ({
  content,
  familyProductBundles,
  loadFamilyProductBundles,
  section,
}) => {
  const theme = useTheme();
  const isOldDesk = useMediaQuery(theme.breakpoints.down('md'));

  useEffect(() => {
    setActiveStep(0);
    const familyBundles = content.familyGroups.map((fg) => ({
      ...fg,
      fields: {
        ...fg.fields.content.find(
          (c) => isContentType(c, 'productBundle') && hasBrandTag(c),
        ).fields,
        header: fg.fields.content.filter((c) => isContentType(c, 'textRich'))[0]
          ?.fields.richText,
        footer: fg.fields.content.filter((c) => isContentType(c, 'textRich'))[1]
          ?.fields.richText,
      },
    }));
    loadFamilyProductBundles({ familyBundles });
  }, []);
  useEffect(() => {
    if (!familyProductBundles?.length || !familyProductBundles.length > 0) {
      return;
    }
    const viewItemList = {
      currencyCode: getCurrencyCode(),
      event: 'view_item_list',
      ecommerce: {
        impressions: familyProductBundles.flatMap((item, index) =>
          flatten(
            item.items.map((bi) => ({
              name: item.fields.title,
              id: bi.fields.product.fields.itemNumber,
              price: `${bi.fields.product.fields.price * bi.fields.quantity}`,
              brand: bi.fields.product.fields.brand || '',
              category: `${bi.fields.product.fields.category}|Water Bundles`,
              variant: bi.fields.product.fields.size,
              list: 'Quick Shop Water - Bundles',
              position: index + 1,
              bundle_name: item.fields.entryTitle,
              quantity: bi.fields.quantity,
            })),
          ),
        ),
      },
    };

    dataLayerPush('Acquisition', viewItemList, 'dlA21');
  }, [familyProductBundles.length]);

  const [activeStep, setActiveStep] = useState(0);

  const handleNext = () => {
    setActiveStep((prevActiveStep) =>
      familyProductBundles?.length === prevActiveStep + 1
        ? 0
        : prevActiveStep + 1,
    );
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) =>
      prevActiveStep === 0
        ? familyProductBundles?.length - 1
        : prevActiveStep - 1,
    );
  };

  if (!familyProductBundles?.length || familyProductBundles?.length === 0) {
    return <></>;
  }

  return (
    <div className={styles.familyProductBundles}>
      <header>
        <RichText richText={content.header.fields.richText} styles={styles} />
      </header>
      <div className={styles.bundleContainer}>
        <div>
          {isOldDesk && (
            <div
              onClick={handleBack}
              onKeyDown={(event) => {
                if (event.key === 'Enter') {
                  handleBack();
                }
              }}
              role="button"
              tabIndex="0"
            >
              <img src={arrowLeft} alt="" />
              {/* <KeyboardArrowLeft /> */}
            </div>
          )}
          <ul>
            {(isOldDesk
              ? [familyProductBundles[activeStep]]
              : familyProductBundles
            ).map((fg, index) => (
              <li key={index}>
                <div className={styles.familyGroupBundle}>
                  <ProductGridItem
                    section={section}
                    displayIndex={index}
                    className={styles.product}
                    product={fg}
                    isBundle
                    isFamilyBundle
                    isQuickShopPage
                  />
                </div>
              </li>
            ))}
          </ul>
          {isOldDesk && (
            <div
              onClick={handleNext}
              onKeyDown={(event) => {
                if (event.key === 'Enter') {
                  handleNext();
                }
              }}
              role="button"
              tabIndex="0"
            >
              <img src={arrowRight} alt="" />
            </div>
          )}
        </div>
      </div>
      <footer>
        <RichText richText={content.footer.fields.richText} styles={styles} />
      </footer>
    </div>
  );
};
FamilyProductBundles.propTypes = {
  content: PropTypes.object,
  familyProductBundles: PropTypes.arrayOf(PropTypes.object).isRequired,
  loadFamilyProductBundles: PropTypes.func.isRequired,
};

export default withContent(
  CONTENT_KEYS,
  CONTENT_TYPE_KEYS,
)(FamilyProductBundles);
